module.exports = __webpack_public_path__ + "img/ContratoHNNacional4.339ae558.png";